<template>
  <UIPreloader class="ui-pivot-table-loader" />
</template>

<script setup lang="ts">
import { UIPreloader } from '@ui/core'
</script>

<style>
.ui-pivot-table-loader {
  @apply flex-auto;
}
</style>
